"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _reactRouterRedux = require("react-router-redux");

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

var _reactIntl = require("react-intl");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _components = require("../../components");

var _Product = require("../../helpers/Product");

var _Cookie = require("../../helpers/Cookie");

var _TVLoginSuccess = require("./TVLoginSuccess.scss");

var _TVLoginSuccess2 = _interopRequireDefault(_TVLoginSuccess);

var _DefaultString = require("../../helpers/DefaultString");

var _stingray_logo_horizontal_white = require("../../../res/images/logo/stingray_logo_horizontal_white.svg");

var _stingray_logo_horizontal_white2 = _interopRequireDefault(_stingray_logo_horizontal_white);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TVLoginSuccess = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(TVLoginSuccess, _Component);

  function TVLoginSuccess(props) {
    (0, _classCallCheck3.default)(this, TVLoginSuccess);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TVLoginSuccess.__proto__ || (0, _getPrototypeOf2.default)(TVLoginSuccess)).call(this, props));

    _this.state = { loading: true, error: null };
    _this.isMusic = _this.props.auth.productName === _Product.PRODUCT_NAMES.Music;
    return _this;
  }

  (0, _createClass3.default)(TVLoginSuccess, [{
    key: "componentDidMount",
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var response;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return (0, _axios2.default)({
                  method: "POST",
                  url: "/code/finishCodeFlow",
                  headers: { "content-type": "application/json" },
                  data: {
                    tvCode: this.props.auth.tvCode,
                    completionData: {
                      loginId: this.props.auth.userInfo && this.props.auth.userInfo.loginId,
                      sessionId: this.props.auth.sessionId
                    }
                  }
                });

              case 3:
                response = _context.sent;

                if (response.data.success) {
                  _context.next = 8;
                  break;
                }

                throw new Error("Did not manage to complete the TV sign-in flow");

              case 8:
                sessionStorage.removeItem(_Cookie.tvCodeSessionStorageName);
                sessionStorage.removeItem(_Cookie.tvCodeExpirySessionStorageName);

              case 10:
                this.setState((0, _extends3.default)({}, this.state, { loading: false }));
                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](0);

                console.error(_context.t0.message);
                this.setState((0, _extends3.default)({}, this.state, { loading: false, error: "Error: " + _context.t0.message }));

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 13]]);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var productClassName = (0, _Product.getProductClassNameWithoutClientId)(this.props.auth.realm, this.props.auth.productName);

      var productName = this.props.auth.productName;

      return _react2.default.createElement(
        "div",
        {
          className: (0, _classnames2.default)(_TVLoginSuccess2.default.tvLoginSuccessComponent, productClassName)
        },
        _react2.default.createElement(
          "div",
          { className: this.isMusic ? _TVLoginSuccess2.default.musicContent : _TVLoginSuccess2.default.content },
          this.state.loading ? _react2.default.createElement(_components.LoadingIndicator, { loading: this.state.loading }) : this.state.error ? _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(
              "div",
              { className: _TVLoginSuccess2.default.title },
              _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.TVCodeFormFailureTitle)
            ),
            _react2.default.createElement(
              "div",
              { className: _TVLoginSuccess2.default.subtitle },
              _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.TVCodeFormFailureSubtitle)
            )
          ) : _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(
              "div",
              { className: _TVLoginSuccess2.default.title },
              _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.TVCodeFormSuccessTitle)
            ),
            _react2.default.createElement(
              "div",
              { className: _TVLoginSuccess2.default.subtitle },
              _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations["TVCodeFormSuccessSubtitle" + (productName.charAt(0).toUpperCase() + productName.slice(1).toLowerCase())])
            )
          )
        ),
        this.isMusic && _react2.default.createElement(
          "div",
          { className: _TVLoginSuccess2.default.logo },
          _react2.default.createElement("img", { src: _stingray_logo_horizontal_white2.default })
        )
      );
    }
  }]);
  return TVLoginSuccess;
}(_react.Component), _class.propTypes = {
  auth: _react.PropTypes.object,
  intl: _reactIntl.intlShape.isRequired,
  pushState: _react.PropTypes.func.isRequired
}, _temp);
exports.default = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(function (state) {
  return { auth: state.auth };
}, { pushState: _reactRouterRedux.push })(TVLoginSuccess));
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/containers/TVLoginSuccess/TVLoginSuccess.js
// module id = 2024
// module chunks = 0